import type { PresentationTaskRunner } from "@slot/presentation";

/**
 * The art the scene loads after the start (the artist's animations, the deferred bundle), which a round holds for
 * before it starts (decision 71): none plays its moments with the stand-ins of art still on its way.
 */
export class ArtLoads {
  private readonly loads: Promise<unknown>[] = [];
  /** How many have not settled: once none, a round starts without a wait (and no timer). */
  private pending = 0;
  private readonly ambientRunner: PresentationTaskRunner;
  private readonly maxWaitSeconds: number;

  public constructor(input: {
    /** The UI's runner, never sped up with the round: the longest wait is the same in every speed mode. */
    ambientRunner: PresentationTaskRunner;
    maxWaitSeconds: number;
  }) {
    this.ambientRunner = input.ambientRunner;
    this.maxWaitSeconds = input.maxWaitSeconds;
  }

  /** A load, settling as it is in or has failed (its stand-in then stays). */
  public track(load: Promise<unknown>): void {
    this.pending += 1;
    this.loads.push(
      load
        .catch(() => undefined)
        .finally(() => {
          this.pending -= 1;
        }),
    );
  }

  /** Settles once every load has, or after the longest wait (a stalled network: the round plays with what is in). */
  public whenReady(): Promise<void> {
    if (this.pending === 0) return Promise.resolve();
    return Promise.race([Promise.all(this.loads).then(() => undefined), this.ambientRunner.sleep(this.maxWaitSeconds)]);
  }
}
